module.exports = __webpack_public_path__ + "static/assets/0a907e4555aebe1ddf4f650b73be0701.png";